var m = require('mithril');
var modalForm = require('../../layout/components/modalForm');
var headingElement = require('../../components/heading');
var Point = require('../models/point');
var buttonElement = require('../../components/button');
var overrideMode = modalForm(require('../models/overrideMode'));
var overrideValue = modalForm(require('../models/overrideValue'));
var writeAlternatePoint = modalForm(require('../models/writeAlternatePoint'));
var isAggregatePoint = require('../isAggregatePoint');


module.exports = {
  view: function (vnode) {
    var ctrl= this;
    ctrl.parentCtrl = vnode.attrs.parentCtrl;
    var isAggregate = isAggregatePoint(ctrl.parentCtrl.point());
    var submitOverrides = function () {
      if (isAggregate) {
        Point.form.overrides(0);
      }
      return Point.save();
    };
    return m('div', [
      m('div.cf.mb2', [
        isAggregate ? m('p.yellow.f6.mt1.mb2', 'Aggregate points are calculated values. Overrides cannot be enabled.') : null,
        m('div.bb.bw1.f4', 'Enable Overrides'),
        m('select.mb2', {
          value: isAggregate ? 0 : Point.form.overrides(),
          id: 'override-enable-input',
          autocomplete: 'off',
          disabled: isAggregate,
          onchange: function (ev) {
            if (isAggregate) return;
            Point.form.overrides(ev.target.value);
          }
        }, [
          m('option', {value: 0}, 'Disable'),
          m('option', {value: 1}, 'Enable'),
        ]),
        Point.errorView(),
        m(buttonElement, {
          label: 'Submit',
          func: submitOverrides,
          class: 'w4 fr'
        })
      ]),
      m(headingElement, {class: 'mb2 pb2 f2', label: 'Override Mode'}),
      (function () {
        if (ctrl.parentCtrl.overrideModeResource()) {
          return m('div.flex.justify-between', [
            m('div', [
              ctrl.parentCtrl.overrideModeResource().path.map(function (ancestor, idx) {
                return m('div.dib.mr2', [
                  m(m.route.Link, {href: '/' + ancestor['@id'].split('/').slice(3).join('/').toLowerCase()}, ancestor.name),
                  ((idx + 1) < ctrl.parentCtrl.overrideModeResource().path.length ? m('span', ' > ') : '')
                ]);
              })
            ]),
            m('div.flex', [
              m(buttonElement, {class: 'mr2', label: m('i.f4.ion-ios-compose.blue.pt2'), func: function () {
                overrideMode.editDialogue.call(overrideMode, ctrl.parentCtrl.point().overridemode);
                overrideMode.form.out(ctrl.parentCtrl.point()['@rid'])
              }
              }),
              m(buttonElement, {label: m('i.f4.ion-ios-trash.red'), func: function () {
                overrideMode.deleteDialogue.call(overrideMode, ctrl.parentCtrl.point().overridemode);
              }})
            ])
          ]);
        } else {
          return m('div.flex.justify-end', [
            m(buttonElement, {label: m('i.ion-plus.f4.blue'), func: overrideMode.editDialogue.bind(overrideMode, {out: ctrl.parentCtrl.point()['@rid']})})
          ])
        }
      })(),
      m(headingElement, {class: 'mb2 pb2 f2', label: 'Override Value'}),
      (function () {
        if (ctrl.parentCtrl.overrideValueResource()) {
          return m('div.flex.justify-between', [
            m('div', [
              ctrl.parentCtrl.overrideValueResource().path.map(function (ancestor, idx) {
                return m('div.dib.mr2', [
                  m(m.route.Link, {href: '/' + ancestor['@id'].split('/').slice(3).join('/').toLowerCase()}, ancestor.name),
                  ((idx + 1) < ctrl.parentCtrl.overrideValueResource().path.length ? m('span', ' > ') : '')
                ]);
              })
            ]),
            m('div.flex', [
              m(buttonElement, {class: 'mr2', label: m('i.f4.ion-ios-compose.blue.pt2'), func: function () {
                  overrideValue.editDialogue.call(overrideValue, ctrl.parentCtrl.point().overridevalue);
                  overrideValue.form.out(ctrl.parentCtrl.point()['@rid'])
                }
              }),
              m(buttonElement, {label: m('i.f4.ion-ios-trash.red'), func: function () {
                  overrideValue.deleteDialogue.call(overrideValue, ctrl.parentCtrl.point().overridevalue);
                }
              })
            ])
          ]);
        } else {
          return m('div.flex.justify-end', [
            m(buttonElement, {label: m('i.ion-plus.f4.blue'), func: overrideValue.editDialogue.bind(overrideValue, {out: ctrl.parentCtrl.point()['@rid']})})
          ]);
        }
      })(),
      m(headingElement, {class: 'mv2 pb2 f2', label: 'Write Alternate Point'}),
      (function () {
        if (ctrl.parentCtrl.writeAlternatePointResource()) {
          return m('div.flex.justify-between', [
            m('div',[
              ctrl.parentCtrl.writeAlternatePointResource().path.map(function (ancestor, idx) {
                return m('div.dib.mr2', [
                  m(m.route.Link, {href: '/' + ancestor['@id'].split('/').slice(3).join('/').toLowerCase()}, ancestor.name),
                  ((idx + 1) < ctrl.parentCtrl.writeAlternatePointResource().path.length ? m('span', ' > ') : '')
                ]);
              })
            ]),
            m('div.flex', [
              m(buttonElement, {class: 'mr2', label: m('i.f4.ion-ios-compose.blue.pt2'), func: function () {
                  writeAlternatePoint.editDialogue.call(writeAlternatePoint, ctrl.parentCtrl.point());
              }}),
              m(buttonElement, {label:  m('i.f4.ion-ios-trash.red'), func: function () {
                writeAlternatePoint.form.writeAlternatePoint(null);
                return writeAlternatePoint.save();
              }})
            ])
          ]);
        } else {
          return m('div.flex.justify-end', [
            m(buttonElement, {label: m('i.ion-plus.f4.blue'), func: writeAlternatePoint.editDialogue.bind(writeAlternatePoint, ctrl.parentCtrl.point())})
          ])
        }
      })()
    ]);
  }
}
